import { render, staticRenderFns } from "./paymentRequest.vue?vue&type=template&id=706a75d5&"
import script from "./paymentRequest.vue?vue&type=script&lang=ts&"
export * from "./paymentRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports